import { useState } from 'react';

export function useScrollWithShadow() {
    const [scrollTop, setScrollTop] = useState(0);
    const [scrollHeight, setScrollHeight] = useState(0);
    const [clientHeight, setClientHeight] = useState(0);

    const onScrollHandler = event => {
        //console.log(event);
        setScrollTop(event.target.scrollTop);
        setScrollHeight(event.target.scrollHeight);
        setClientHeight(event.target.clientHeight);
    };

    function getShadow() {
        const isBottom = clientHeight === scrollHeight - Math.round(scrollTop);
        const isTop = scrollTop === 0;
        const isBetween =
            Math.round(scrollTop) > 0 && clientHeight < scrollHeight - Math.round(scrollTop);

        let shadow = true;

        if (isTop) {
            shadow = true;
        } else if (isBetween) {
            shadow = true;
        } else if (isBottom) {
            shadow = false;
        }
        return shadow;
    }

    function getShadowStyle() {
        const isBottom = clientHeight === scrollHeight - Math.round(scrollTop);
        const isTop = scrollTop === 0;
        const isBetween =
            Math.round(scrollTop) > 0 && clientHeight < scrollHeight - Math.round(scrollTop);

        let background = 'linear-gradient(175deg, rgba(255, 255, 255, 0) 17%, #FFFFFF 90%)';

        if (isTop) {
            background = 'linear-gradient(175deg, rgba(255, 255, 255, 0) 17%, #FFFFFF 90%)';
        } else if (isBetween) {
            let perc = 100 - (scrollHeight - Math.round(scrollTop) - clientHeight) / 6 - 15;
            console.log(perc);
            background =
                'linear-gradient(175deg, rgba(255, 255, 255, 0) ' + perc + '%, #FFFFFF 90%)';
        } else if (isBottom) {
            background = 'linear-gradient(175deg, rgba(255, 255, 255, 0) 100%, #FFFFFF 90%)';
        }
        return background;
    }

    return { shadow: getShadow(), onScrollHandler, background: getShadowStyle() };
}
